module.exports = __webpack_public_path__ + "img/headshot.1fb8a29c.svg";